import { render, staticRenderFns } from "./HuaweiMobileServiceAddAccountModal.vue?vue&type=template&id=70bafa38&scoped=true"
import script from "./HuaweiMobileServiceAddAccountModal.vue?vue&type=script&lang=js"
export * from "./HuaweiMobileServiceAddAccountModal.vue?vue&type=script&lang=js"
import style0 from "./HuaweiMobileServiceAddAccountModal.vue?vue&type=style&index=0&id=70bafa38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bafa38",
  null
  
)

export default component.exports